import {useRankedBrandTraits} from "./brand-traits";
import {httpsCallable} from "firebase/functions";
import {functions} from "hooks/firebase";
import {useEffect, useState} from "react";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";
import {BrandExamplesRequest, BrandExamplesResponse} from "data/models/shared/brand-examples";

export type ThreeBrandExamples = [string, string, string];


export function useBrandExampleImages():
    [ThreeBrandExamples | null, boolean, Error | null] {
  const [rankedBrandTraits, rankedTraitsLoading, rankedTraitsError] = useRankedBrandTraits();
  const [threeBrandExamples, setThreeBrandExamples] = useState<ThreeBrandExamples | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (rankedTraitsError !== null) {
      setError(rankedTraitsError);
      return;
    }
    if (rankedTraitsLoading) {
      return;
    }
    if (isNullOrUndefined(rankedBrandTraits)) {
      return;
    }

    const brandTraitsRequest: BrandExamplesRequest = {
      trait1: rankedBrandTraits[0].traitKey,
      trait2: rankedBrandTraits[1].traitKey,
    }

    const brandExamplesFunction = httpsCallable<BrandExamplesRequest, BrandExamplesResponse>(functions, 'brandExamples');

    brandExamplesFunction(brandTraitsRequest).then(result => {
      setThreeBrandExamples(result.data);
      setError(null);
    }).catch((error) => {
      setError(error as Error);
    });
  }, [
    // masterLoading, -- this flag prevents re-calling the
    rankedTraitsError, rankedTraitsLoading, rankedBrandTraits,
  ]);

  return [threeBrandExamples, rankedTraitsLoading, error];
}
